/*
 * Mobile - PDP - Authentication Badge Above The Fold  --  variant: Next to Brand Name
 * Moonshot experiment id: 20094411   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-01-12
 * Audience: MOBILE   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_auth_badge
 */
MGExp.run('pdp_m_auth_badge', { name: "Mobile - PDP - Authentication Badge Above The Fold / Next to Brand Name", platform: 'mobile', target: 'pdp' }, function () {
  !(function () {
    let e = [],
      n = [];
    !(async function (t, i, a, d, s) {
      let c = {
        multi_target_selectors: e,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: n,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(t, i, a, d, s, c);
    })(
      [".pdp-brand-name a"],
      ".msai-certified-badge-added",
      function (e, n) {
        const [t] = n,
          i = document.createElement("span");
        i.className = "msai-certified-badge";
        const a = document.createElement("img");
        ((a.src =
          "https://cdn.shopify.com/s/files/1/0133/9195/3977/files/icon-cert_87cb4328-4d0e-46df-abb1-a8a8c0aba69a.svg?v=1717096707"),
          (a.alt = "Certified"));
        const d = document.createElement("span");
        ((d.className = "msai-certified-badge-text"),
          (d.textContent = "Certified Authentic"),
          i.appendChild(a),
          i.appendChild(d));
        const s = t.parentElement;
        (t.insertAdjacentElement("afterend", i),
          s.classList.add("msai-certified-badge-added"));
      },
      "\n  .msai-certified-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-left: 8px;\n    padding: 4px 10px;\n    background-color: #ffffff;\n    border: 1px solid #e5e5e5;\n    border-radius: 4px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    font-size: 11px;\n    font-weight: 500;\n    color: #000000;\n    letter-spacing: 0.3px;\n    white-space: nowrap;\n  }\n  \n  .msai-certified-badge img {\n    width: 14px;\n    height: 14px;\n    display: block;\n    flex-shrink: 0;\n  }\n  \n  .msai-certified-badge-text {\n    line-height: 1;\n  }\n  \n  .pdp-brand-name {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n",
    );
  })();
});
